import React from 'react'

function Page(props) {
    return (
        <div className='page'>
            {props.children}
        </div>
    )
}

export default Page
